import './Logo.sass';

const Logo = ({ className, primaryColor, secondaryColor }: any) => {
    return (<svg className={`Logo ${className}`} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" height="40"
        viewBox="0 0 1602.9 447.3" xmlSpace="preserve">
        <style type="text/css">
            {`.st0{fill:${secondaryColor};}
                    .st1{fill:${primaryColor};}
                    .st2{fill:${secondaryColor};stroke:${secondaryColor};stroke-miterlimit:10;}
                    .st3{fill:none;stroke:${secondaryColor};stroke-width:4;stroke-miterlimit:10;}`}
        </style>
        <g id="Calque_2">
        </g>
        <g id="Calque_1">
            <g>
                <g>
                    <path className="st0" d="M110.4,289.9c-13,10.8-32.8,17.6-49.3,17.6C13.6,307.4,0,263.8,0,224.2C0,185.1,14.2,141,60,141
				c21.5,0,40.2,12.5,51.5,31.1L94,183.4c-7.9-13-19.2-22.6-35.1-22.6c-31.7,0-37.4,39.6-37.4,64c0,24.9,5.7,63.4,37.9,63.4
				c10.8,0,20.9-2.8,30-8.5v-42.5H51v-18.7h59.4V289.9z"/>
                    <path className="st0" d="M165.9,143.8h100.2v18.7h-79.3v48.1h65.7v18.7h-65.7v57.2h79.8v18.7H165.9V143.8z" />
                    <path className="st0" d="M318.2,143.8h54.3c26.6,0,48.1,12.5,48.1,43.6c0,19.8-13,39.1-32.8,45.3l39.6,65.1l-18.1,10.8l-41.3-73h-30
				v69.1H317V143.8H318.2z M365.7,217.4c19.8,0,33.4-11.3,33.4-29.4c0-14.7-8.5-25.5-27.2-25.5h-33.4v54.9H365.7z"/>
                    <path className="st0" d="M575.8,224.2c0,13-1.1,83.2-57.2,83.2c-26,0-57.2-18.7-57.2-83.2c0-64,30.6-83.2,57.2-83.2
				C544.6,141,575.8,159.7,575.8,224.2z M483.5,224.2c0,23.2,4.5,63.4,35.7,63.4s35.7-40.2,35.7-63.4c0-23.8-4.5-64-35.7-64
				C487.4,160.8,483.5,200.4,483.5,224.2z"/>
                </g>
                <g>
                    <path className="st0" d="M1013.4,285.9h22.6V162.5h-22.6v-18.7h66.2v18.7H1057v124h22.6v18.7h-66.2V285.9z" />
                    <path className="st0" d="M1165.7,162.5H1121v-18.7h108.7v18.7h-43.6v142.1h-20.9V162.5H1165.7z" />
                    <path className="st0" d="M1288,143.8v109.8c0,23.2,6.8,34.5,28.3,34.5c26,0,31.7-11.3,31.7-34.5V143.8h20.9v119.5
				c0,21.5-15.3,44.2-50.4,44.2c-35.1,0-50.4-22.1-50.4-45.3V143.8H1288z"/>
                    <path className="st0" d="M1438.6,253.6c4,19.8,13.6,34.5,35.1,34.5c17,0,30-9.1,30-27.2c0-19.8-16.4-24.9-32.3-31.1
				c-23.2-9.6-45.9-15.9-45.9-46.4c0-27.2,22.1-42.5,47-42.5c26.6,0,42.5,15.3,49.3,40.2l-19.8,5.7c-4-15.9-11.9-26.6-29.4-26.6
				c-13,0-26,6.8-26,21.5c0,15.3,9.1,19.2,21.5,24.9l34.5,15.3c14.7,7.9,22.1,20.9,22.1,37.9c0,30.6-21.5,48.1-51,48.1
				c-30,0-48.7-19.2-53.8-48.1L1438.6,253.6z"/>
                </g>
                <path className="st0" d="M760.3,253.6c4,19.8,13.6,34.5,35.1,34.5c17,0,30-9.1,30-27.2c0-19.8-16.4-24.9-32.3-31.1
			c-23.2-9.6-45.9-15.9-45.9-46.4c0-27.2,22.1-42.5,47-42.5c26.6,0,42.5,15.3,49.3,40.2l-19.8,5.7c-4-15.9-11.9-26.6-29.4-26.6
			c-13,0-26,6.8-26,21.5c0,15.3,9.1,19.2,21.5,24.9l34.5,15.3c14.7,7.9,22.1,20.9,22.1,37.9c0,30.6-21.5,48.1-51,48.1
			c-30,0-48.7-19.2-53.8-48.1L760.3,253.6z"/>
                <path className="st1" d="M966.4,224.2c0-87.8-65.7-159.7-150.6-169.8L794.9,0l-20.9,53.8C689,64,623.3,136.4,623.3,223.6
			c0,87.8,65.7,159.7,150.6,169.8l20.9,53.8l20.9-53.8C900.7,383.8,966.4,311.4,966.4,224.2z M794.9,365.2
			c-78.1,0-141.5-63.4-141.5-141.5S716.7,82.1,794.9,82.1s141.5,63.4,141.5,141.5S873,365.2,794.9,365.2z"/>
            </g>
            <g>
                <path className="st2" d="M1554.5,126.8h-6.9V77.2h15.9c2.4,0,4.6,0.2,6.8,0.7c2.1,0.5,4,1.3,5.6,2.3c1.6,1.1,2.9,2.5,3.8,4.2
			s1.4,3.9,1.4,6.4c0,3.6-1.1,6.6-3.4,8.8c-2.2,2.2-5.1,3.7-8.7,4.3l13.9,22.8h-8.4l-12.6-22h-7.4V126.8z M1554.5,98.9h8
			c1.6,0,3.2-0.1,4.5-0.4c1.4-0.3,2.6-0.7,3.7-1.4c1.1-0.6,1.9-1.4,2.5-2.5c0.6-1,0.9-2.3,0.9-3.7c0-1.5-0.3-2.7-0.9-3.7
			c-0.6-1-1.4-1.8-2.4-2.4c-1-0.6-2.2-1-3.5-1.3c-1.4-0.3-2.8-0.4-4.3-0.4h-8.5V98.9z"/>
            </g>
            <circle className="st3" cx="1562.8" cy="102.8" r="38.1" />
        </g>
    </svg>

    );
};

export default Logo;
